<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">My Products</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                            <!-- <li class="breadcrumb-item"><router-link to="/my-products">My Products</router-link></li> -->
                            <li class="breadcrumb-item active">My Products</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-6">
                            <ul class="nav nav-tabs" id="custom-content-below-tab" role="tablist">
                                <li class="nav-item">
                                    <router-link class="nav-link" to="/my-products/robots">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23">
                                            <g id="robot_icon" transform="translate(-33 -220)">
                                                <path id="Exclusion_1" data-name="Exclusion 1" d="M16,16H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H16a2,2,0,0,1,2,2V14A2,2,0,0,1,16,16ZM4.5,12a.5.5,0,1,0,0,1h9a.5.5,0,1,0,0-1Zm9-8A2.5,2.5,0,1,0,16,6.5,2.5,2.5,0,0,0,13.5,4Zm-9,0A2.5,2.5,0,1,0,7,6.5,2.5,2.5,0,0,0,4.5,4Z" transform="translate(36 223)" fill="#1b1b1b" opacity="0.6"/>
                                                <rect id="Rectangle_147" data-name="Rectangle 147" width="12" height="2" rx="1" transform="translate(39 241)" fill="#1b1b1b"/>
                                                <path id="Rectangle_148" data-name="Rectangle 148" d="M0,0H0A2,2,0,0,1,2,2V6A2,2,0,0,1,0,8H0A0,0,0,0,1,0,8V0A0,0,0,0,1,0,0Z" transform="translate(55 227)" fill="#1b1b1b"/>
                                                <path id="Rectangle_150" data-name="Rectangle 150" d="M2,0H6A2,2,0,0,1,8,2V2A0,0,0,0,1,8,2H0A0,0,0,0,1,0,2V2A2,2,0,0,1,2,0Z" transform="translate(41 220)" fill="#1b1b1b"/>
                                                <path id="Rectangle_149" data-name="Rectangle 149" d="M2,0H2A0,0,0,0,1,2,0V8A0,0,0,0,1,2,8H2A2,2,0,0,1,0,6V2A2,2,0,0,1,2,0Z" transform="translate(33 227)" fill="#1b1b1b"/>
                                            </g>
                                        </svg>
                                        Robot
                                    </router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link" to="/my-products/fund-manager">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24">
                                            <g id="fund_manager_icon" transform="translate(-34.5 -273)">
                                                <path id="Icon_awesome-user-tie" data-name="Icon awesome-user-tie" d="M14.991,13.528,12.75,22.5l-1.5-6.375,1.5-2.625H8.25l1.5,2.625L8.25,22.5,6.009,13.528A6.289,6.289,0,0,0,0,19.8v1.95A2.251,2.251,0,0,0,2.25,24h16.5A2.251,2.251,0,0,0,21,21.75V19.8a6.289,6.289,0,0,0-6.009-6.272Z" transform="translate(34.5 273)" fill="#1b1b1b" opacity="0.6"/>
                                                <path id="Intersection_2" data-name="Intersection 2" d="M4.5,7a6,6,0,1,1,6,6A6,6,0,0,1,4.5,7Z" transform="translate(34.5 272)" fill="#1b1b1b"/>
                                            </g>
                                        </svg>
                                        Fund Managers
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-3">
                                    
                                </div>
                                <div class="col-9">
                                    <div class="input-group">
                                        <input type="search" class="form-control" v-model="search" placeholder="Search">
                                        <div class="input-group-append">
                                            <button type="submit" class="btn btn-secondary">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <h5 class="title my-3">Active</h5> -->

                    <h5 class="text-mude" v-if="fundmanager.length <1 && !loading">
                        Fund Manager Not Available.
                    </h5>

                    <div class="row" v-if="fundmanager.length > 0 ">
                        <div class="col-lg-4 col-sm-6 col-6" v-for="fund in fundActive" :key="fund.id">
                            <div class="card card_robot">
                                <div class="card-body">
                                    <figure class="robot_img">
                                        <img :src="fund.image" alt="">
                                    </figure>
                                    <div class="text">
                                        <h6 class="name">{{fund.name}}</h6>

                                        <div class="row">
                                            <div class="col-6">
                                                <p class="info">Risk Level</p>
                                                <p class="info_text">
                                                    <span v-if="fund.risk_level == 3" class="badge badge-danger">HIGH</span>
                                                    <span v-else-if="fund.risk_level == 2" class="badge badge-warning">MEDIUM</span>
                                                    <span v-else-if="fund.risk_level == 1" class="badge badge-success">LOW</span>
                                                    <span v-else>-</span>
                                                </p>
                                            </div>
                                            <!-- <div class="col-6">
                                                <p class="info">Trade Report</p>
                                                <p class="info_text">
                                                    <a :href="fund.trade_report_file" target="_blank" rel="noopener noreferrer">
                                                        <svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                                            <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                                            <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                                            <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                                        </svg>
                                                    </a>
                                                </p>
                                            </div> -->
                                            <div class="col-12">
                                                <p class="info">Strategy</p>
                                                <div class="d-lg-flex d-block align-items-center justify-content-between">
                                                    <div class="">
                                                        <div v-for="(data,index) in fund.strategy.split(';')" :key="data.id">
                                                            <template v-if="index == 0">
                                                            <p class="m-0" v-if="data.length >=30" v-html="data ? data.substring(0, 30)+'...' : '-'"></p>
                                                            <p class="m-0" v-else v-html="data ? data : '-'"></p>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <!-- Button trigger modal -->
                                                    <button type="button" class="btn read_btn btn-sm" v-if="fund.strategy.length>=30" @click="viewMore(fund)" data-toggle="modal" data-target="#staticBackdrop">
                                                        Read More
                                                    </button>
                                                    <!-- <button type="button" v-if="fund.strategy.length>=30" @click="viewMore(fund)" class="btn read_btn btn-sm" data-bs-toggle="modal" data-bs-target="#viewDetail">Read More</button> -->
                                                </div>
                                                <!-- <p class="desc" v-html="fund.strategy ? fund.strategy : '-'"></p> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="button">
                                        <router-link :to="'/fund-manager/'+fund.id" class="btn btn_red btn-block">View Detail</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="loading">
                        <div class="col-lg- col-sm-6 col-6" v-for="index in 3" :key="index">
                            <div class="card">
                                <div class="card-body">
                                    <ContentLoader/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="text-end m-3">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="text-center">
                                        <h3 class="title">"{{productName}}"</h3>
                                    </div>
                                    <div v-for="(itm,index) in strategy.split(';')" :key="itm">
                                        <h6 class="fw-bold mb-0" style="font-size: 10pt;" v-if="index == 0">Strategy</h6>
                                        <h6 class="fw-bold mb-0" style="font-size: 10pt;" v-if="index == 1">Deskripsi</h6>
                                        <h6 class="fw-bold mb-0" style="font-size: 10pt;" v-if="index == 2">Robot Type</h6>
                                        <h6 class="fw-bold mb-0" style="font-size: 10pt;" v-if="index == 3">Recommended Lot Size</h6>
                                        <h6 class="fw-bold mb-0" style="font-size: 10pt;" v-if="index == 4">Recommended Active Pair</h6>
                                        <h6 class="fw-bold mb-0" style="font-size: 10pt;" v-if="index == 5">Recommended Pair Option</h6>
                                        <div v-if="index !== 3 && index !== 5" class="text-secondary mb-2" v-html="itm ? itm : '-'"></div>
                                        <p v-if="index == 3 && itm"><span class="badge bg-dark me-1" v-for="ls in itm.split(',')" :key="ls">{{ls}}</span></p>
                                        <p v-if="index == 5 && itm"><span class="badge bg-dark me-1" v-for="po in itm.split(',')" :key="po">{{po}}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import ContentLoader from "../components/ContentLoader.vue"

import jwt_decode from 'jwt-decode'
import axios from "axios";

export default {
    name: "Dashboard",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        ContentLoader,
    },
    data(){
        return{
            // robots: [],
            fundmanager: [],
            search: '',
            strategy: '',
            productName: '',
            loading: false
        }
    },
    computed: {
		// robotsActive(){
		// 	return this.robots.filter(p => p.is_active == true);
		// },
		// robotsNonactive(){
		// 	return this.robots.filter(p => p.is_active == false);
		// },
		fundActive(){
			// return this.fundmanager.filter(f => f.is_active == true && f.risk_level !== null);
            if (!this.search){
                return this.fundmanager.filter(f => f.is_active == true && f.risk_level !== null)
            }

            return this.fundmanager.filter(fund => {
                return fund.name.toLowerCase().includes(this.search.toLowerCase()) && fund.is_active == true && fund.risk_level !== null
            })
		},
		fundNonactive(){
			return this.fundmanager.filter(f => f.is_active == false);
		}
	},
    async mounted(){
        window.scrollTo(0,0)
        this.loading = true
        
        var token = localStorage.getItem('access_token')
        var access_token = jwt_decode(token)
        const user_id = access_token.user_id
        if(!localStorage.getItem('user_id')){
            localStorage.setItem('user_id', user_id)
        }

        await axios.get(`investor/${localStorage.user_id}`)
        .then(() => {
            // console.log('Profile: ', result.data)
            // if(result.data.data.profiling_risk_level == null)
            // {
            //   this.$router.push('profiling')
            // }
        }).catch(() => {
            // console.log('Error Profile: ', err.response)
        })

        await axios.get(`investor/fundmanager/?only_has_broker=true`)
        .then(response => {
            // console.log('Fund Manager All: ', response.data.data)
            this.loading = false
            this.fundmanager = response.data.data
        }).catch(() => {
            this.loading = false
            // console.log('Error Fund Manager: ', err.response)
        })

        // await axios.get(`investor/${localStorage.user_id}/products`)
        // .then(result => {
        //     // console.log('Products Robot: ', result.data.data.robots)
        //     // this.robots = result.data.data.robots

        //     console.log('Products Fund Managers: ', result.data.data.fund_managers)
        //     this.fundmanager = result.data.data.fund_managers
        // }).catch((err) => {
        //     console.log('Error Profile: ', err.response)
        // })

    },
    methods: {
        viewMore(fund){
            this.strategy = fund.strategy
            this.productName = fund.name
        }
    }
}
</script>

<style>
.content .nav-tabs{
    border: none;
    margin-bottom: 30px;
}
.content .nav-tabs .nav-item .nav-link svg{
    margin-right: 10px;
}
.content .nav-tabs .nav-item .nav-link{
    background: rgba(0, 0, 0, 0.0);
    border: none;
    border-radius: 0;
    border-bottom: 3px solid var(--grey);
    padding: 15px 25px;
    font-weight: 700;
    color: var(--dark-grey);
}
.content .nav-tabs .nav-item a.nav-link:hover{
    background: rgba(0, 0, 0, 0.2);
}
.content .nav-tabs .nav-item .nav-link.active{
    background: rgba(0, 0, 0, 0.1);
    border-bottom: 3px solid var(--red);
}
button.read_btn{
    padding: 0 5px;
    font-size: 10pt;
    background: #dbdbdb !important;
    color: var(--darkGrey) !important;
    margin-bottom: 10px;
}
button.read_btn:hover{
    background: #c9c9c9 !important;
}
</style>